import { Constants as ChingariConstants } from "./chingari.io";
import { Constants as AstroConstants } from "./astrolive.app";

export const getDomainConstants = () => {
  if (typeof window !== "undefined") {
    if (window?.location?.hostname?.includes("astrolive")) {
      return AstroConstants;
    }
  }

  return ChingariConstants;
};

export const getConstantsFromDomain = (hostname: string) => {
  if (hostname?.includes("astrolive")) return AstroConstants;
  return ChingariConstants;
};
